import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { BASE_URL } from "../../config";

const initialState = {
  tab: "home",
  isLoading: false,
  isLoadingGetUser: false,
  isLoadingGetLocation: false,
  isLoadingUpdateStatus: false,
  isLoadingUpdateStatusDetect: false,
  isLoadingAddUser: false,
  isLoadingDeleteUser: false,
  isLoadingUpdateUser: false,
  isLoadingDetect: false,
  isLoadingViolationCodeInter: false,
  isLoadingViolationTypeInter: false,
  isLoadingViolationCodeMex: false,
  isLoadingViolationTypeMex: false,
  isLoadingViolation: false,
  isLoadingViolationMex: false,
  isLoadingViolationCodeInterDetect: false,
  isLoadingViolationTypeInterDetect: false,
  isLoadingViolationCodeMexDetect: false,
  isLoadingViolationTypeMexDetect: false,
  isLoadingViolationDetect: false,
  isLoadingViolationMexDetect: false,
  isLoadingSubmitJotForm: false,
  isLoadingUpdateStatusLocation: false,
  isLoadingDeleteLocation: false,
  isLoadingResource: false,
  isLoadingUpdateResource: false,
  error: null,
  success: false,
  status: "",
  statusDetect: false,
  statusViolation: false,
  statusViolationDetect: 0,
  statusSubmitJotForm: false,
  statusUpdateLocation: false,
  statusDeleteLocation: false,
  statusUpdateResource: false,
  data: [],
  dataCheck: [],
  users: [],
  dataDetect: {},
  violationCode: [],
  violationTypes: [],
  dataLocation: [],
  dataResource: [],
};

const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateTab(state, action) {
      state.tab = action.payload;
    },
    getAllData(state, action) {
      state.isLoading = action.payload.isLoading;
      state.error = action.payload.error;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
      }
    },
    getDataCheck(state, action) {
      state.isLoading = action.payload.isLoading;
      state.error = action.payload.error;
      state.dataCheck = action.payload.dataCheck;
    },
    getAllUsers(state, action) {
      state.isLoadingGetUser = action.payload.isLoadingGetUser;
      state.error = action.payload.error;
      state.users = action.payload.users;
    },
    submitJotForm(state, action) {
      state.isLoadingSubmitJotForm = action.payload.isLoadingSubmitJotForm;
      state.error = action.payload.error;
      state.statusSubmitJotForm = action.payload.statusSubmitJotForm;
    },
    getLocation(state, action) {
      state.isLoadingGetLocation = action.payload.isLoadingGetLocation;
      state.error = action.payload.error;
      state.dataLocation = action.payload.dataLocation;
    },
    updateStatusLocation(state, action) {
      state.isLoadingUpdateStatusLocation =
        action.payload.isLoadingUpdateStatusLocation;
      state.error = action.payload.error;
      state.statusUpdateLocation = action.payload.statusUpdateLocation;
    },
    deleteLocation(state, action) {
      state.isLoadingDeleteLocation = action.payload.isLoadingDeleteLocation;
      state.error = action.payload.error;
      state.statusDeleteLocation = action.payload.statusDeleteLocation;
    },
    updateStatus(state, action) {
      state.isLoadingUpdateStatus = action.payload.isLoadingUpdateStatus;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateStatusDetect(state, action) {
      state.isLoadingUpdateStatusDetect =
        action.payload.isLoadingUpdateStatusDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    addUser(state, action) {
      state.isLoadingAddUser = action.payload.isLoadingAddUser;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    updateUser(state, action) {
      state.isLoadingUpdateUser = action.payload.isLoadingUpdateUser;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    deleteUser(state, action) {
      state.isLoadingDeleteUser = action.payload.isLoadingDeleteUser;
      state.error = action.payload.error;
      state.status = action.payload.status;
    },
    detectImg(state, action) {
      state.isLoadingDetect = action.payload.isLoadingDetect;
      state.error = action.payload.error;
      state.statusDetect = action.payload.statusDetect;
      state.dataDetect = action.payload.dataDetect;
    },
    detectUrl(state, action) {
      state.isLoadingDetect = action.payload.isLoadingDetect;
      state.error = action.payload.error;
      state.status = action.payload.status;
      state.dataDetect = action.payload.dataDetect;
    },
    updateViolationCodeInter(state, action) {
      state.isLoadingViolationCodeInter =
        action.payload.isLoadingViolationCodeInter;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationTypeInter(state, action) {
      state.isLoadingViolationTypeInter =
        action.payload.isLoadingViolationTypeInter;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationCodeMex(state, action) {
      state.isLoadingViolationCodeMex =
        action.payload.isLoadingViolationCodeMex;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationTypeMex(state, action) {
      state.isLoadingViolationTypeMex =
        action.payload.isLoadingViolationTypeMex;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolation(state, action) {
      state.isLoadingViolation = action.payload.isLoadingViolation;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationMex(state, action) {
      state.isLoadingViolationMex = action.payload.isLoadingViolationMex;
      state.error = action.payload.error;
      state.statusViolation = action.payload.statusViolation;
    },
    updateViolationCodeInterDetect(state, action) {
      state.isLoadingViolationCodeInterDetect =
        action.payload.isLoadingViolationCodeInterDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationTypeInterDetect(state, action) {
      state.isLoadingViolationTypeInterDetect =
        action.payload.isLoadingViolationTypeInterDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationCodeMexDetect(state, action) {
      state.isLoadingViolationCodeMexDetect =
        action.payload.isLoadingViolationCodeMexDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationTypeMexDetect(state, action) {
      state.isLoadingViolationTypeMexDetect =
        action.payload.isLoadingViolationTypeMexDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationDetect(state, action) {
      state.isLoadingViolationDetect = action.payload.isLoadingViolationDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    updateViolationMexDetect(state, action) {
      state.isLoadingViolationMexDetect =
        action.payload.isLoadingViolationMexDetect;
      state.error = action.payload.error;
      state.statusViolationDetect = action.payload.statusViolationDetect;
    },
    getResources(state, action) {
      state.isLoadingResource = action.payload.isLoadingResource;
      state.error = action.payload.error;
      state.dataResource = action.payload.dataResource;
    },
    updateResource(state, action) {
      state.isLoadingUpdateResource = action.payload.isLoadingUpdateResource;
      state.error = action.payload.error;
      state.statusUpdateResource = action.payload.statusUpdateResource;
    },
  },
});

// Reducer
export default slice.reducer;

let getAllDataRequestId = 0;

export function updateTab(tab) {
  return async (dispatch) => {
    dispatch(slice.actions.updateTab(tab));
  };
}

export function getAllData() {
  return async (dispatch) => {
    const requestId = ++getAllDataRequestId;
    dispatch(slice.actions.getAllData({ isLoading: true }));
    await axios
      .get(`${BASE_URL}/api_mex/get_data`, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      .then(function (response) {
        if (requestId !== getAllDataRequestId) return;
        dispatch(
          slice.actions.getAllData({ isLoading: false, data: response.data })
        );
      })

      .catch(function (error) {
        if (requestId !== getAllDataRequestId) return;
        dispatch(
          slice.actions.getAllData({ isLoading: false, error: error.message })
        );
      });
  };
}

export function getDataResource() {
  return async (dispatch) => {
    dispatch(slice.actions.getResources({ isLoadingResource: true }));
    await axios
      .get(
        `${BASE_URL}/api_mex/get_resources`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getResources({
            isLoadingResource: false,
            dataResource: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getResources({
            isLoadingResource: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateResource(formData) {
  console.log(formData);
  return async (dispatch) => {
    dispatch(
      slice.actions.updateResource({
        isLoadingUpdateResource: true,
      })
    );

    await axios
      .post(
        `${BASE_URL}/api_mex/upload_file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateResource({
              isLoadingUpdateResource: false,
              statusUpdateResource: response.data.status
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatusLocation({
              isLoadingUpdateStatusLocation: false,
              error: error.message,
            })
          );
        }, 2000);
      });
  };
}

export function getDataCheck() {
  return async (dispatch) => {
    dispatch(slice.actions.getDataCheck({ isLoading: true }));
    await axios
      .get(
        `${BASE_URL}/api_mex/get_user_check_mex_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getDataCheck({
            isLoading: false,
            dataCheck: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getDataCheck({ isLoading: false, error: error.message })
        );
      });
  };
}

export function submitJotForm(formData) {
  return async (dispatch) => {
    dispatch(
      slice.actions.submitJotForm({
        isLoadingSubmitJotForm: true,
        statusSubmitJotForm: false,
      })
    );
    await axios
      .post(
        `${BASE_URL}/api_mex/get-location`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.submitJotForm({
              isLoadingSubmitJotForm: false,
              statusSubmitJotForm: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.submitJotForm({
            isLoadingSubmitJotForm: false,
            statusSubmitJotForm: false,
            error: error.message,
          })
        );
      });
  };
}

export function getLocation() {
  return async (dispatch) => {
    dispatch(slice.actions.getLocation({ isLoadingGetLocation: true }));
    await axios
      .get(
        `${BASE_URL}/api_mex/get-data-location`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getLocation({
            isLoadingGetLocation: false,
            dataLocation: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getLocation({
            isLoadingGetLocation: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateStatusLocation(_id, status, index) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateStatusLocation({
        isLoadingUpdateStatusLocation: true,
      })
    );

    await axios
      .post(
        `${BASE_URL}/api_mex/update_status_location`,
        { _id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatusLocation({
              isLoadingUpdateStatusLocation: false,
              statusUpdateLocation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatusLocation({
            isLoadingUpdateStatusLocation: false,
            error: error.message,
          })
        );
      });
  };
}

export function deleteLocation(_id) {
  return async (dispatch) => {
    dispatch(
      slice.actions.deleteLocation({
        isLoadingDeleteLocation: true,
      })
    );

    await axios
      .delete(`${BASE_URL}/api_mex/delete_location`, {
        data: { _id },
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.deleteLocation({
              isLoadingDeleteLocation: false,
              statusDeleteLocation: response.data.status === "success",
            })
          );
        }, 2000);
      })
      .catch(function (error) {
        dispatch(
          slice.actions.deleteLocation({
            isLoadingDeleteLocation: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateStatus(_id, status) {
  return async (dispatch) => {
    dispatch(slice.actions.updateStatus({ isLoadingUpdateStatus: true }));

    await axios
      .put(
        `${BASE_URL}/api_mex/update_status`,
        { _id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatus({
              isLoadingUpdateStatus: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatus({ isLoading: false, error: error.message })
        );
      });
  };
}

export function updateStatusDetect(_id, status) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateStatusDetect({ isLoadingUpdateStatusDetect: true })
    );

    await axios
      .put(
        `${BASE_URL}/api_mex/update_status_detect`,
        { _id, status },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateStatusDetect({
              isLoadingUpdateStatusDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateStatusDetect({
            isLoadingUpdateStatusDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function getAllUsers() {
  return async (dispatch) => {
    dispatch(slice.actions.getAllData({ isLoadingGetUser: true }));
    await axios
      .get(
        `${BASE_URL}/api_mex/get_users`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.getAllUsers({
            isLoadingGetUser: false,
            users: response.data,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.getAllUsers({
            isLoadingGetUser: false,
            error: error.message,
          })
        );
      });
  };
}

export function addUser(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.addUser({ isLoadingAddUser: true }));
    await axios
      .post(
        `${BASE_URL}/api_mex/add_user`,
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.addUser({
              isLoadingAddUser: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        setTimeout(() => {
          dispatch(
            slice.actions.addUser({
              isLoadingAddUser: false,
              error: error.message,
            })
          );
        }, 2000);
      });
  };
}

export function updateUser(formValues) {
  return async (dispatch) => {
    dispatch(slice.actions.updateUser({ isLoadingUpdateUser: true }));
    await axios
      .put(
        `${BASE_URL}/api_mex/update_user`,
        {
          ...formValues,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateUser({
              isLoadingUpdateUser: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.addUser({
            isLoadingUpdateUser: false,
            error: error.message,
          })
        );
      });
  };
}

export function deleteUser(data) {
  return async (dispatch) => {
    dispatch(slice.actions.deleteUser({ isLoadingDeleteUser: true }));
    await axios
      .delete(
        `${BASE_URL}/api_mex/delete_user`,
        {
          data: {
            id: data,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.deleteUser({
              isLoadingDeleteUser: false,
              status: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        setTimeout(() => {
          dispatch(
            slice.actions.deleteUser({
              isLoadingDeleteUser: false,
              error: error.message,
            })
          );
        }, 2000);
      });
  };
}

export function detectImg(formData) {
  return async (dispatch) => {
    dispatch(slice.actions.detectImg({ isLoadingDetect: true }));
    await axios
      .post(
        `${BASE_URL}/api_mex/check-violation-mexico-user-check-text-imgs`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.detectImg({
            isLoadingDetect: false,
            dataDetect: response.data,
            statusDetect: response.data.status,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.detectImg({
            isLoadingDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function detectUrl(url, desc) {
  return async (dispatch) => {
    dispatch(slice.actions.detectImg({ isLoadingDetect: true }));
    await axios
      .post(
        `${BASE_URL}/api_mex/check-violation-mexico-user-check-url`,
        { url, desc },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        dispatch(
          slice.actions.detectUrl({
            isLoadingDetect: false,
            dataDetect: response.data,
            statusDetect: response.data.status,
          })
        );
      })

      .catch(function (error) {
        dispatch(
          slice.actions.detectUrl({
            isLoadingDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeInter(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeInter({
        isLoadingViolationCodeInter: true,
      })
    );
    await axios
      .post(
          `${BASE_URL}/api_mex/update_violation_code`,
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeInter({
              isLoadingViolationCodeInter: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeInter({
            isLoadingViolationCodeInter: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeInter(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeInter({
        isLoadingViolationTypeInter: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_violation_type`,
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeInter({
              isLoadingViolationTypeInter: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeInter({
            isLoadingViolationTypeInter: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeMex(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeMex({
        isLoadingViolationCodeMex: true,
      })
    );
    await axios
      .post(
        `${BASE_URL}/api_mex/update_mex_violation_code`,
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeMex({
              isLoadingViolationCodeMex: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeMex({
            isLoadingViolationCodeMex: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeMex(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeMex({
        isLoadingViolationTypeMex: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_mex_violation_type`,
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeMex({
              isLoadingViolationTypeMex: false,
              statusViolation: response.data.status,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeMex({
            isLoadingViolationTypeMex: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolation(_id, violation) {
  return async (dispatch) => {
    dispatch(slice.actions.updateViolation({ isLoadingViolation: true }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_violation`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolation({
              isLoadingViolation: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolation({
            isLoading: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationMex(_id, violation) {
  return async (dispatch) => {
    dispatch(slice.actions.updateViolationMex({ isLoadingViolationMex: true }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_mex_violation`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationMex({
              isLoadingViolationMex: false,
              statusViolation: response.data.success,
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationMex({
            isLoading: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeInterDetect(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeInterDetect({
        isLoadingViolationCodeInterDetect: true,
      })
    );
    await axios
      .post(
        `${BASE_URL}/api_mex/update_violation_code_detect`,
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeInterDetect({
              isLoadingViolationCodeInterDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
          dispatch(getAllData());
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeInterDetect({
            isLoadingViolationCodeInterDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeInterDetect(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeInterDetect({
        isLoadingViolationTypeInterDetect: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_violation_type_detect`,
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeInterDetect({
              isLoadingViolationTypeInterDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
          dispatch(getAllData());
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeInterDetect({
            isLoadingViolationTypeInterDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationCodeMexDetect(_id, names) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationCodeMexDetect({
        isLoadingViolationCodeMexDetect: true,
      })
    );
    await axios
      .post(
        `${BASE_URL}/api_mex/update_mex_violation_code_detect`,
        {
          _id: _id,
          names: names,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationCodeMexDetect({
              isLoadingViolationCodeMexDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
          dispatch(getAllData());
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationCodeMexDetect({
            isLoadingViolationCodeMexDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationTypeMexDetect(_id, selectedViolations) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationTypeMexDetect({
        isLoadingViolationTypeMexDetect: true,
      })
    );

    const dataFiltered = selectedViolations.map((item) => ({
      name: item.name,
      color: item.color,
    }));

    await axios
      .post(
        `${BASE_URL}/api_mex/update_mex_violation_type_detect`,
        {
          _id: _id,
          violations: dataFiltered,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationTypeMexDetect({
              isLoadingViolationTypeMexDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
          dispatch(getAllData());
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationTypeMexDetect({
            isLoadingViolationTypeMexDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationDetect(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationDetect({ isLoadingViolationDetect: true })
    );

    await axios
      .put(
        `${BASE_URL}/api_mex/update_violation_detect`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationDetect({
              isLoadingViolationDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationDetect({
            isLoadingViolationDetect: false,
            error: error.message,
          })
        );
      });
  };
}

export function updateViolationMexDetect(_id, violation) {
  return async (dispatch) => {
    dispatch(
      slice.actions.updateViolationMexDetect({
        isLoadingViolationMexDetect: true,
      })
    );

    await axios
      .put(
        `${BASE_URL}/api_mex/update_mex_violation_detect`,
        { _id, violation },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        setTimeout(() => {
          dispatch(
            slice.actions.updateViolationMexDetect({
              isLoadingViolationMexDetect: false,
              statusViolationDetect: Date.now(),
            })
          );
        }, 2000);
      })

      .catch(function (error) {
        dispatch(
          slice.actions.updateViolationMexDetect({
            isLoadingViolationMexDetect: false,
            error: error.message,
          })
        );
      });
  };
}
